if (!customElements.get('sr-half')) {
    customElements.define('sr-half', class SRHalf extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                toggle: '.js-sr-half-toggle'
            }

            this.toogles = this.querySelectorAll(this.selectors.toggle);
            this.init();
        }

        init() {
            this.toogles.forEach(el => {
                el.addEventListener('click', e => {
                    e.preventDefault();
                    el.classList.toggle('is-open');
                })
            })
        }
    });
}
